import { Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { DataCard, DataCardDefaultItem } from "@ofqual/portal-components/components/DataCard/DataCard";
import { PersonalDetailsModel } from "../../domain/PersonalDetailsModel";
import { useSelector } from "react-redux";
import { authSelector } from "../../redux/selectors";
import { countriesService } from "../../services";

export const PersonalDetails: React.FC<{
    personalDetails: PersonalDetailsModel | undefined
}> = ({ personalDetails }) => {

    const { token } = useSelector(authSelector);
    const [country, setCountry] = useState("Unknown");

    useEffect(() => {
        countriesService.getAll({ token })
            .then((response) => {
                if (personalDetails?.isInsideUk) {
                    setCountry("United Kingdom");
                    return;
                }
                setCountry(response.filter(obj => obj.id === personalDetails?.countryId)[0]?.label)
            });
    }, [token, country, personalDetails?.countryId, personalDetails?.isInsideUk]);

    const displayPersonalDetails = (personalDetails: PersonalDetailsModel) => {
        let items: DataCardDefaultItem[] = [
            {
                itemType: "DEFAULT",
                key: "Full name",
                value: personalDetails?.fullName,
            },
            {
                itemType: "DEFAULT",
                key: "Telephone number",
                value: personalDetails?.telephoneNumber,
            },
            {
                itemType: "DEFAULT",
                key: "Email",
                value: personalDetails?.email,
            },
            {
                itemType: "DEFAULT",
                key: "Country",
                value: country
            },
            {
                itemType: "DEFAULT",
                key: "Address line 1",
                value: personalDetails?.addressLineOne,
            },
            {
                itemType: "DEFAULT",
                key: "Address line 2",
                value: personalDetails?.addressLineTwo,
            },
            {
                itemType: "DEFAULT",
                key: "Town/City",
                value: personalDetails?.townCity,
            }
        ]

        if (personalDetails?.isInsideUk !== undefined && !personalDetails?.isInsideUk) {
            items.push(
                {
                    itemType: "DEFAULT",
                    key: "Region, state or province",
                    value: personalDetails?.region,
                },
                {
                    itemType: "DEFAULT",
                    key: "Zip code",
                    value: personalDetails?.postcode,
                },
            );
        } else {
            items.push(
                {
                    itemType: "DEFAULT",
                    key: "Postcode",
                    value: personalDetails?.postcode,
                },
            );
        }

        return items
    }

    return (
        <>
            <div style={{ overflowWrap: 'break-word' }}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <DataCard
                            showHeading={false}
                            heading={null}
                            items={personalDetails !== undefined ? displayPersonalDetails(personalDetails) : []}
                            hasAction={false}
                            actionDescription={null}
                            actionButtonText={null}
                            actionFunction={null}
                            headingComponent={"h1"}
                        />
                    </Grid>
                </Grid>
            </div>
        </>
    );
};
